import React, { FC, useEffect, useState } from 'react';
import axios from 'axios';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import * as Yup from 'yup';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmationModal from '../shared/ConfirmationModal';
import NewconfirmationModal from '../shared/NewconfirmationModal';
import AllFailureModal from '../shared/AllFailureModal';

interface Company {
  company_id: string;
  company_name: string;
}

const HrUpdate: FC = () => {
  const { id } = useParams();
  const [updateData, setUpdateData] = useState({
    userid: id ,
    name: '',
    email: '',
    mobile: '',
    password: '',
    linkedinid: '',
    designation: '',
    company_id: '',
    company_name:'',
    isactive: 1,
  });
  const [modalShow, setModalShow] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
      const [successMessage, setSuccessMessage] = useState("");
      
      const [showFailureModal, setShowFailureModal] = useState(false);
      const [failureMessage, setFailureMessage] = useState("");
    
    const [modalMessage, setModalMessage] = useState('');
    const [pendingValues, setPendingValues] = useState<any>(null); 
  const [updatedValues, setUpdatedValues] = useState<any>(null);
  const [companies, setCompanies] = useState<Company[]>([]);
  const [filteredCompanies, setFilteredCompanies] = useState<Company[]>([]);
  const [companySearch, setCompanySearch] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const callHrUpdateApi = async (data: any) => {
    const url = `${process.env.REACT_APP_API_URL}hr_details/updatehr`;
    return await axios.put(url, data);
  };



  const fetchCompanies = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}companyDetails/companylist`);
      setCompanies(response.data.companies || response?.data);
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    mobile: Yup.string().required('Mobile number is required'),
    linkedinid: Yup.string().url('Invalid URL'),
    designation: Yup.string().required('Designation is required'),
    company_id: Yup.string().required('Company is required'),
  });
  const getHrByIdApi = async (id: string) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}hr_details/gethr/${id}`;
      const response = await axios.get(url);
      return response.data[0] || {};
    } catch (error) {
      console.error('Error fetching HR by ID:', error);
      return {};
    }
  };

  useEffect(() => {
    (async () => {
      if (id) {
        const data = await getHrByIdApi(id);
        setUpdateData(prevData => ({ ...prevData, ...data })); 
      }
    })();
  }, [id]);

useEffect(() => {
    fetchCompanies();
  }, []);

const handleSearch = (value: string) => {
  setCompanySearch(value);
  
  if (value.trim() === '') {
    setFilteredCompanies([]);
    return;
  }

  // Filter + remove duplicates by company_name
  const filtered = companies
    .filter(company => company.company_name.toLowerCase().includes(value.toLowerCase()))
    .reduce((acc: Company[], current) => {
      const alreadyExists = acc.some(item => item.company_name === current.company_name);
      if (!alreadyExists) {
        acc.push(current);
      }
      return acc;
    }, []);

  setFilteredCompanies(filtered);
};

const handleSelect = (company: Company, setFieldValue: (field: string, value: any) => void) => {
  setFieldValue('company_id', company.company_id);
  setCompanySearch(company.company_name);
  setFilteredCompanies([]);
};

const handleUpdateConfirmation = async (isConfirmed: boolean) => {
  setModalShow(false);
  if (isConfirmed && pendingValues) {
    await callHrUpdateApi(pendingValues);
    setSuccessMessage(" HR updated successfully!");
    setShowSuccessModal(true);
    setPendingValues(null);
    setTimeout(() => navigate('/hrlist'), 3000);
  } else {
    setFailureMessage("Failed to update the HR.");
    setShowFailureModal(true);
  }
};
  return (
    <Container className='mt-5'>
      <ToastContainer />
      <Row className='justify-content-center'>
        <Col md={8}>
          <Card className='shadow'>
            <Card.Header className='bg-info text-white text-center'>
              <h4>Update HR Details</h4>
            </Card.Header>
            <Card.Body>
            <Formik
                enableReinitialize
                initialValues={updateData} 
                validationSchema={validationSchema}
                onSubmit={(values) => {
                if (JSON.stringify(values) === JSON.stringify(updateData)) {
                  setSuccessMessage("No changes were made.");
                  setShowSuccessModal(true);
                } else {
                try {
                  setPendingValues(values);
                  setModalMessage("Are you sure you want to update the hr?");
                  setModalShow(true);
                } catch (error: any) {
                  setFailureMessage(error.response?.data?.message || "An error occurred. Please try again.");
                  setShowFailureModal(true);
                }
                }
                }}
              >
                {({ values, setFieldValue }) => (
                  <Form>
                    <Row className='mb-3'>
                      <Col md={12}>
                        <label className='form-label'>Name</label>
                        <Field name='name' type='text' className='form-control' />
                        <ErrorMessage name='name' component='div' className='text-danger' />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label className="form-label">Email</label>
                        <Field name="email" type="email" className="form-control" />
                        <ErrorMessage name="email" component="div" className="text-danger" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label className="form-label">Mobile</label>
                        <Field name="mobile" type="text" className="form-control" />
                        <ErrorMessage name="mobile" component="div" className="text-danger" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label className="form-label">Password</label>
                        <div className="position-relative">
                          <Field
                            name="password"
                            type={showPassword ? "text" : "password"}
                            className="form-control pe-5"
                            autoComplete="new-password"
                          />
                          <i
                            className={`position-absolute top-50 translate-middle-y end-0 me-3 fas ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          ></i>
                        </div>
                        <ErrorMessage name="password" component="div" className="text-danger" />
                        {/* </div> */}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label className="form-label">Linkedin ID</label>
                        <Field name="linkedinid" type="linkedinid" className="form-control" />
                        <ErrorMessage name="linkedinid" component="div" className="text-danger" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label className="form-label">Designation</label>
                        <Field name="designation" type="designation" className="form-control" />
                        <ErrorMessage name="designation" component="div" className="text-danger" />
                      </Col>
                    </Row>                    

                    <Row className='mb-3'>
                      <Col md={12}>
                        <label className='form-label'>Company</label>
                        <Field name='company_name' type='hidden'/>
                        <input
                          type='text'
                          className='form-control'
                          value={values.company_name || ""}
                          onChange={(e) => {
                            setFieldValue('company_name', e.target.value); 
                            handleSearch(e.target.value);
                          }}
                          placeholder='Search Company'
                          autoComplete='off'
                        />
                        {filteredCompanies.length > 0 && (
                          <ul className='list-group position-absolute w-100'>
                            {filteredCompanies.map(company => (
                              <li key={company.company_id} className='list-group-item list-group-item-action' onClick={() =>{
                                setFieldValue('company_name', company.company_name);
                                handleSelect(company, setFieldValue)}}>
                              
                                {company.company_name}
                              </li>
                            ))}
                          </ul>
                        )}
                        <ErrorMessage name='company_id' component='div' className='text-danger' />
                      </Col>
                    </Row>
          <div className="row">
              <div className="text-center my-4">
                <button type="submit" className="btn btn-success">
                  Update
                </button>
                <button  className="btn btn-danger ms-3" onClick={() => navigate(-1)}>
                  Go Back
                </button>
              </div>
            </div>
                  </Form>
                )}
              </Formik>
             <ConfirmationModal
                     show={modalShow}
                     modalMessage={modalMessage}
                     onHide={() => setModalShow(false)}
                     confirmation={handleUpdateConfirmation}
                     operationType="Update"
                   />
                    <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
                         <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage}  operationType="OK" timeoutDuration={5000}/>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default HrUpdate;
